import React, { useState, useEffect } from "react";
import "./Gallery.css";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function Gallery() {
  const [category, setCategory] = useState("all");
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    { id: 1, category: "birthdays", url: "https://i.postimg.cc/nh7hV12m/11.png" },
    { id: 2, category: "birthdays", url: "https://i.postimg.cc/hGt48qgL/12.png" },
    { id: 3, category: "birthdays", url: "https://i.postimg.cc/sDCV6WsD/13.png" },
    { id: 4, category: "birthdays", url: "https://i.postimg.cc/8ztNznWj/14.png" },
    { id: 5, category: "birthdays", url: "https://i.postimg.cc/Ls5RYBBv/15.png" },
    { id: 6, category: "birthdays", url: "https://i.postimg.cc/905jk33N/16.png" },
    { id: 7, category: "birthdays", url: "https://i.postimg.cc/4dhgwf09/IMG-3628.jpg" },
    { id: 8, category: "events", url: "https://i.postimg.cc/SQ9Xx8rc/7.png" },
    { id: 9, category: "weddings", url: "https://i.postimg.cc/nVYPYfPw/4.png" },
    { id: 10, category: "weddings", url: "https://i.postimg.cc/4xSVjGP5/1.png" },
    { id: 11, category: "weddings", url: "https://i.postimg.cc/C1HZMpG9/10.png" },
    { id: 12, category: "weddings", url: "https://i.postimg.cc/yxjSjCW0/2.png" },
    { id: 13, category: "weddings", url: "https://i.postimg.cc/90C7yQXW/3.png" },
    { id: 14, category: "weddings", url: "https://i.postimg.cc/HW95dX3j/5.png" },
    { id: 15, category: "weddings", url: "https://i.postimg.cc/13fNGTSN/6.png" },
    { id: 16, category: "weddings", url: "https://i.postimg.cc/T3F5C92N/8.png" },
    { id: 17, category: "weddings", url: "https://i.postimg.cc/LsPY71n9/9.png" },
  ];

  const filteredImages = category === "all"
    ? images
    : images.filter((img) => img.category === category);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % filteredImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [filteredImages]);

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };

  const handleCategoryChange = (newCategory) => {
    setCategory(newCategory);
    setActiveIndex(0);
  };

  const renderImage = (url, alt, className, fallbackWidth = 800, fallbackHeight = 600) => {
    if (url && url !== "" && !url.includes("example.com")) {
      return <img src={url} alt={alt} className={className} />;
    }
    return (
      <img
        src={`/api/placeholder/${fallbackWidth}/${fallbackHeight}`}
        alt={alt}
        className={className}
      />
    );
  };

  return (
    <div className="div">
      <Header />
      <div className="apple-gallery-container">
        <h1 className="apple-gallery-title">Galerie</h1>
        <p className="apple-gallery-subtitle">
          Des moments inoubliables capturés avec notre WoodyBooth
        </p>

        <div className="apple-gallery-categories">
          {["all", "birthdays", "events", "weddings"].map((cat) => (
            <button
              key={cat}
              className={`apple-gallery-category-btn ${
                category === cat ? "apple-gallery-category-active" : ""
              }`}
              onClick={() => handleCategoryChange(cat)}
            >
              {cat === "all"
                ? "Tous"
                : cat === "birthdays"
                ? "Anniversaires"
                : cat === "events"
                ? "Événements"
                : "Mariages"}
            </button>
          ))}
        </div>

        <div className="apple-gallery-grid">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className={`apple-gallery-item ${
                index === activeIndex ? "apple-gallery-item-active" : ""
              }`}
              onClick={() => handleThumbnailClick(index)}
              style={{ "--i": index }}
            >
              {renderImage(image.url, `Image ${image.id}`, "apple-gallery-thumbnail")}
              <div className="apple-gallery-item-overlay">
                <span className="apple-gallery-item-text">Capturé avec notre WoodyBooth</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Gallery;
